import { FilterOption } from '../types';

export function keyExtractor(val: FilterOption) {
  return val.value;
}

export function filterDisabled(val: FilterOption) {
  return Boolean(val.disabled);
}
